module.exports = __webpack_public_path__ + "static/media/exits.7f645626.svg";